<template>
    <div class=" start">
        <div class="cover" v-if='start.acf'>
            <div class="welcome">
                <div class="block">
                    <div :class="{'phase2':phase===2, 'phase3': phase===3}" class="upper">
                        <div class="text first">
                            <div :class="{show:anim}" class="inner">
                                <span v-html="boldFirstLine(start.acf.startbildschirm.oberzeile)"
                                      v-if="phase!==3"></span>
                                <span v-html="boldFirstLine(start.acf.startbildschirm.beschreibung)"
                                      v-if="phase===3"></span>
                            </div>
                        </div>
                    </div>
                    <div :class="{'phase2':phase===2, 'phase3': phase===3}" class="lower">
                        <div class="text">
                            <div class="inner"
                                 v-html="boldFirstLine(start.acf.startbildschirm.unterzeile)">
                            </div>
                            <div class="inner"
                                 >
                            </div>
                        </div>
                        <div class="diagonal line"></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import store from '@/store'

    export default {
        store,
        name: 'Start',
        data() {
            return {
                phase: 1
            }
        },
        props: {
            anim: Boolean
        },
        created: function () {

            setTimeout(() => {
                this.$emit('update:anim', true)
            }, 800);
            setTimeout(() => {
                this.phase = 2;
            }, 2200);
            setTimeout(() => {
                this.phase = 3;
                this.$emit('update:phase3', true)
            }, 3700);
        },
        destroyed() {
            this.$emit('update:anim', false)
        },
        methods: {
            toggle() {
                this.anim = !this.anim;
            },
            boldFirstLine(str) {
                let parts = str.split('<br />')
                let firstline = "<span class='firstline'>" + parts[0] + "</span>"
                return firstline + '<br>' + parts[1]
            }
        },
        computed: {
            start: () => store.state.start,
        }
    }
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" type="text/scss">
    .start {
        /*background-color: #282629;*/
        position: absolute;
        top: 0;
        @include mobile {

            position: relative;
        }
    }

    .cover {
        width: 100%;
        padding-top: 72px;
        height: 100vh;
        /*transition: height 1s ease;*/
        @include mobile {
            height: 40vh;
        }
        position: relative;
        color: #fff;
        top: 0;
        /*opacity: 0.4;*/
    }

    .welcome {
        position: absolute;
        height: 80%;
        top: 0;
        left: 10%;
        width: 1080px;
        @include mobile {
            width: 280px;
            height: 100%;
            /*left: 0;*/
        }
        display: flex;
        flex-direction: column;
        justify-content: center;

        .block {
            text-align: right;
            width: 100%;
            font-family: $zilla;
            font-style: normal;
            font-weight: 300;
            font-size: 64px;
            @include tablet {
                font-size: 40px;
            }
            @include mobile {
                font-size: 24px;
                margin-top: 20%;
            }
            line-height: 110%;
            letter-spacing: 0.02em;
            color: #333;
            position: relative;

            & > div {
                display: flex;

                .line {
                    margin: 0;
                    transition: transform 0.3s ease 0.3s, opacity 0.6s ease 0.3s;
                    width: 50px;
                    opacity: 0;
                    @include mobile {
                        width: 20px;
                    }

                    &.diagonal {
                        opacity: 1;
                    }
                }

                .inner {
                    font-weight: 300;

                    .firstline {
                        font-weight: 600;
                    }
                }

                &.upper {
                    position: absolute;
                    top: 0;
                    left: 180px;

                    @include mobile {
                        left: 0;
                    }

                    .text {
                        opacity: 1;
                        transition: opacity 0.5s linear 0.5s;
                    }

                    transition: transform 1s linear 0.5s, opacity 0.5s linear 1s;

                    &.phase2 {
                        //transform: translateX(450px);
                        .text {
                            opacity: 0;
                        }
                    }

                    &.phase3 {
                        left: 100px;
                        @include mobile {
                            left: 20px;
                        }

                        .text.first {
                            padding-left: 150px;
                            @include mobile {
                                padding-left: 50px;
                            }
                        }

                        .line {
                            border-left: 3px solid $zzcolor;
                        }
                    }

                    .text {
                        @include mobile {
                        }

                        &.first {
                            padding-left: 70px;
                            /*background-color: red;*/
                            .inner {
                                text-align: right;
                                transform: translateX(-150%);
                                @include mobile {
                                    transform: translateX(-250%);
                                }
                                opacity: 1;

                                &.show {
                                    transform: translateX(0);
                                    transition: transform 0.6s ease 0.3s, opacity 0.3s ease 0.3s;
                                }
                            }
                        }
                    }

                    .line {
                        transform-origin: bottom;
                        transform: skew(0) translateX(3px);
                        border-right: 3px solid $zzcolor;

                        &.diagonal {
                            z-index: 1000;
                            position: relative;
                            width: 50px;
                            transform: skew(-45deg) translateX(0px); /*}*/
                        }
                    }
                }

                &.lower {
                    text-align: left;
                    padding-left: 50px;
                    border-right: 3px solid $zzcolor;
                    z-index: 1001;
                    background-color: #F2F2F2;
                    position: absolute;
                    left: 180px;
                    top: 0;
                    transform: translateX(-100%) skew(-45deg);
                  padding-bottom: 5px;
                    transition: transform 0.6s ease 0.2s, opacity 0.3s linear 0.3s;
                    overflow: hidden;
                    @include mobile {
                        left: 40px;
                    }

                    &.phase2 {
                        transform: translateX(0px) skew(-45deg);
                        opacity: 1;

                        .text {
                            opacity: 1;
                            transform: translateX(0);
                            transition: transform 0.6s ease, opacity 0.3s linear 0.3s;
                        }
                    }

                    &.phase3 {
                        .line {
                            border-left: 3px solid $zzcolor;
                        }
                    }

                    .text {
                        transform: translateX(100%);
                        opacity: 0;

                        .inner {
                            transform: translateX(0) skew(45deg);
                            opacity: 1;
                        }
                    }

                    .line {
                        border-left: 3px solid transparent;
                        transition: border-color 1s ease 0.3s;

                        &.diagonal {
                            transform-origin: bottom;
                        }
                    }
                }
            }
        }

        .desc {
            height: 200px;
            text-align: left;
            padding-left: 50%;
            font-family: $zilla;
            font-style: normal;
            font-weight: 300;
            font-size: 24px;
            line-height: 140%;
            /* or 36px */
            overflow: hidden;

            .text {
                transition: transform 0s;
                transform: translateY(-100%);
                padding-top: 30px;

                &.show {
                    transition: transform 0.8s ease 0.8s;
                    transform: translateY(0);
                }
            }

            letter-spacing: 0.02em;
        }
    }
</style>
